@if (imagesList().length) {
@if (isBrowser) {
<div class="image-viewer-wrapper">
    @if (imagesReady()) {
    <!-- Preview Image -->

    @if (!isMobile()) {
    <div [redZoom]="images[imageIndex]!.image" [redZoomThumb]="images[imageIndex]!.image" [redZoomClass]="classes">
        <ng-container [ngTemplateOutlet]="preview"></ng-container>
    </div>
    } @else {
    <div>
        <ng-container [ngTemplateOutlet]="preview"></ng-container>
    </div>
    }

    <div class="image-list">
        <!-- Image Slider -->
        <owl-carousel-o [options]="customOptions" #slideCarousel (dragging)="isDragging = $event.dragging">
            @for (image of images; track image.image; let i = $index) {
            <ng-template [id]="i + ''" carouselSlide [width]="image.widthForSlider">
                <div class="owl-image-list-container">
                    <picture [class.image-active]="(previewCarousel?.slidesOutputData?.startPosition ?? 0) === i">
                        <img class="clickable list-image" (click)="previewCarousel.to(i + '')" [src]="image.image" loading="lazy" />
                    </picture>
                </div>
            </ng-template>
            }
        </owl-carousel-o>

        <!-- navigation button -->

        @if (imagesList().length > 1) {
        <!-- Previous -->
        <button [disabled]="(previewCarousel?.slidesOutputData?.startPosition ?? 0) === 0" [class.btn-disabled]="(previewCarousel?.slidesOutputData?.startPosition ?? 0) === 0" class="prev-btn" type="button" (click)="previewCarousel.to((previewCarousel?.slidesOutputData?.startPosition ?? 0) - 1 + '')">
            <img [src]="IMAGE_URLS.leftNavIcon" class="navigation-icon" />
        </button>

        <!-- Next -->
        <button [disabled]="(previewCarousel?.slidesOutputData?.startPosition ?? 0) === imagesList().length - 1" [class.btn-disabled]="(previewCarousel?.slidesOutputData?.startPosition ?? 0) === imagesList().length - 1" class="next-btn" type="button" (click)="previewCarousel.to((previewCarousel?.slidesOutputData?.startPosition ?? 0) + 1 + '')">
            <img [src]="IMAGE_URLS.rightNavIcon" class="navigation-icon" />
        </button>
        }
    </div>
    }
</div>
} @else {
<!-- server side viewer -->
<div class="server-side-viewer">
    <div class="image-container">
        <img [src]="previewImage" class="preview-image" loading="eager" fetchpriority="high" />
    </div>

    <ul class="server-side-image-list">
        @for (image of images; track image.image; let i = $index) {
        <li>
            <div class="image-list-container">
                <img [src]="image?.image" class="image-list-item" [loading]="i === 0 ? 'eager' : 'lazy'" />
            </div>
        </li>
        }

        <div class="server-side-navigation">
            <button class="left-navigation">
                <img [src]="IMAGE_URLS.leftArrowWhite" class="navigation-icon" />
            </button>
            <button class="right-navigation">
                <img [src]="IMAGE_URLS.rightArrowWhite" class="navigation-icon" />
            </button>
        </div>
    </ul>
</div>
}
} @else {
<!-- for no Preview Image state -->
<div class="image-viewer-wrapper">
    <div class="image-container">
        <img [src]="IMAGE_URLS.noImagePlaceholder" class="display-image" loading="eager" />
    </div>
</div>
}

<ng-template #preview>
    <owl-carousel-o [options]="customOptionsSingleImage" #previewCarousel (translated)="setCarouselStartPosition()" (dragging)="isDragging = $event.dragging" (changed)="seeChangedIndex($event)">
        @for (image of images; track image.image; let i = $index) {
        <ng-template [id]="i + ''" carouselSlide>
            <div class="display-image-container" (click)="isMobile() ? openImagesInFullScreenInMobile() : null">
                <picture>
                    <img class="display-image" [src]="image.image" [loading]="i === 0 ? 'eager' : 'lazy'" [attr.fetchpriority]="i === 0 ? 'high' : 'auto'" />
                </picture>
            </div>
        </ng-template>
        }
    </owl-carousel-o>
    @if (!sectionType()) {
    <div class="d-none d-sm-none d-md-none d-lg-block full-screen-container">
        <button class="full-screen-btn" (click)="openImagesInFullScreen()">
            <img [src]="IMAGE_URLS.magnifyingIcon" class="search-icon" />
            <span>View in Fullscreen</span>
        </button>
    </div>
    }
</ng-template>